import React, { ReactNode } from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {authSelector} from '../../store/auth';
interface ProtectedRouteProps {
    children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const {access_token} = useSelector(authSelector);
    const location = useLocation();
    const isAuthenticated =access_token; // Implementa tu lógica de autenticación aquí

    if (!isAuthenticated &&   location.pathname!=='/login') {
        // Si el usuario no está autenticado, redirígelo a la página de inicio de sesión
        return <Navigate to="/login" />;
    }
    if(isAuthenticated &&   location.pathname==='/login'){
        return <Navigate to="/" />;
    }

    // Si el usuario está autenticado, permite el acceso a la ruta
    return <>{children}</>;
};

export default ProtectedRoute;
